import { useParams, useNavigate } from 'react-router-dom';
import { useProjectById } from '@/hooks';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { BillableItemForm } from '@/components/BillableItemForm';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { ArrowLeft } from 'lucide-react';

export default function BillableItemCreatePage() {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const { data: projectData, isLoading, error } = useProjectById(projectId);

  const project = projectData?.project;

  if (isLoading) {
    return (
      <DashboardLayout title="Create Billable Item">
        <div className="space-y-6">
          <Skeleton className="h-12 w-full max-w-2xl" />
          <Skeleton className="h-96" />
        </div>
      </DashboardLayout>
    );
  }

  if (error || !project || !projectId) {
    return (
      <DashboardLayout title="Create Billable Item">
        <div className="rounded-lg border border-destructive bg-destructive/10 p-4">
          <p className="text-sm text-destructive">
            Failed to load project: {(error as Error)?.message || 'Project not found'}
          </p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout
      title="Create Billable Item"
      actions={
        <Button variant="outline" size="sm" onClick={() => navigate(`/projects/${project.id}`)}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Project
        </Button>
      }
    >
      <div className="max-w-3xl">
        <div className="mb-6">
          <p className="text-sm text-muted-foreground">
            Adding billable item to <span className="font-medium">{project.name}</span> (#{project.project_number})
          </p>
        </div>

        <BillableItemForm
          mode="create"
          projectId={project.id}
          projectNumber={project.project_number}
          workflowStage={project.workflow_stage}
          isTemplate={project.is_template}
        />
      </div>
    </DashboardLayout>
  );
}
